/** Sample prices shown on the search results pages (not live fares) */
export const DISPLAY_PRICE_MIN = 199;
export const DISPLAY_PRICE_MAX = 399;

/**
 * Stable pseudo-random demo price for a seed. Always a whole dollar amount
 * ending in 9 (199, 209, 219 … 399).
 */
export function seededRandomPrice(seed, min = DISPLAY_PRICE_MIN, max = DISPLAY_PRICE_MAX) {
  let n = 0;
  const s = String(seed ?? 0);
  for (let i = 0; i < s.length; i += 1) {
    n = (n << 5) - n + s.charCodeAt(i);
    n |= 0;
  }
  const steps = Math.floor((max - min) / 10) + 1;
  const fraction = ((Math.abs(n) * 9301 + 49297) % 233280) / 233280;
  return min + Math.floor(fraction * steps) * 10;
}

export function applyDisplayPrice(item, seed, { multiply = 1 } = {}) {
  const perUnit = seededRandomPrice(seed);
  const total = Math.round(perUnit * multiply * 100) / 100;
  return { ...item, perPerson: perUnit, perNight: perUnit, perDay: perUnit, price: total };
}
